export default "__VITE_ASSET__BvzKQcAk__"